import { URLPath } from '../../utils/url-utils.js';
export const baseSearchRequest = (req, method, contentType, path) => {
    const url = new URLPath(`${req.url}${path}`);
    url.addParam('organizationId', req.organizationId);
    if (req.authentication) {
        url.addParam('authentication', req.authentication);
    }
    return {
        accessToken: req.accessToken,
        method,
        contentType,
        url: url.href,
        origin: 'searchApiFetch',
    };
};
export const getOrganizationIdQueryParam = (req) => `organizationId=${req.organizationId}`;
export const getAuthenticationQueryParam = (req) => `authentication=${encodeURIComponent(req.authentication)}`;
